<template>
	<div class="home">
		<HeaderBar title="诊疗方案"></HeaderBar>
		<div class="center-box-no-footer">

			<StaticSingleSelect label="选择药物" :selectkey.sync="treatmentSel" :list="treatmentList" labelProp="label"
				valueProp="guid" @changeSelect="treatmentChange" />
			<div class="add-btn-box" v-show="hasmed">
				<van-button size="small" plain type="info" @click="addTreatment">确认添加</van-button>
			</div>


			<van-collapse v-model="activeNames">
				<van-collapse-item v-for="(item,index) in medList" :key="index" title="标题1" :name="index">
					<template #title>
						<div class="item-title">{{item.bd002002}}</div>
					</template>
					<FormNormalInput label="药物类型" v-model="item.bd001002" />
					<StaticSingleSelect label="规格" :selectkey.sync="item.bq403004"
						:list="$utils.setStandardList(item.bd002004.split(','))" />

					<StaticSingleSelect label="给药途径" :selectkey.sync="item.bq403006"
						:list="$utils.setStandardList(item.bd002005.split(','))" />

					<StaticSingleSelect label="用法" :selectkey.sync="item.bq403010"
						:list="$utils.setStandardList(item.bd002007.split(','))" />


					<van-cell-group title="用量">
						<van-row class="no-label">
							<van-col span="8">
								<FormNormalInput label="" v-model="item.bq403008" />
							</van-col>
							<van-col span="16">
								<StaticSingleSelect label="" :selectkey.sync="item.bq4030082"
									:list="$utils.setStandardList(item.bd002006.split(','))" />
							</van-col>
						</van-row>
					</van-cell-group>

					<DateSelect label="开始用药" v-model="item.bq403014" timeNow />
					<DateSelect label="停药时间" v-model="item.bq4030152" closeabled />
					<FormNormalInput label="停药说明" v-model="item.bq4030153" />
					<FormNormalInput label="备注" v-model="item.bq403012" />
					<van-button block size="small" plain type="danger" @click="removeMed(item.guid,item.bd002002)">移除
					</van-button>
					<!-- <FormNormalInput label="规格" v-model="item.bq403004" /> -->
					<!-- <FormNormalInput label="给药途径" v-model="item.bq403006" /> -->
					<!-- <FormNormalInput label="用法" v-model="item.bq403010" /> -->
					<!-- <FormNormalInput label="用量" v-model="item.bq403008Name" /> -->
					<!--          <FormNormalInput label="开始用药" v-model="item.bq403014" />
          <FormNormalInput label="停药时间" v-model="item.bq4030152" />
          <FormNormalInput label="停药说明" v-model="item.bq4030153" />
          <FormNormalInput label="备注" v-model="item.bq403012" /> -->
				</van-collapse-item>
			</van-collapse>

			<!--      <van-collapse v-model="activeNames">
        <van-collapse-item v-for="(item,index) in medList" :key="index" title="标题1" :name="index">
          <template #title>
            <div class="item-title">{{item.bd002002}}</div>
          </template>
          <FormNormalInput label="药物类型" v-model="item.bd001002" readonly />
          <FormNormalInput label="规格" v-model="item.bq403004" readonly />
          <FormNormalInput label="给药途径" v-model="item.bq403006" readonly />
          <FormNormalInput label="用法" v-model="item.bq403010" readonly />
          <FormNormalInput label="用量" v-model="item.bq403008Name" readonly />
          <FormNormalInput label="开始用药" v-model="item.bq403014" readonly />
          <FormNormalInput label="停药时间" v-model="item.bq4030152" readonly />
          <FormNormalInput label="停药说明" v-model="item.bq4030153" readonly />
          <FormNormalInput label="备注" v-model="item.bq403012" readonly />
        </van-collapse-item>
      </van-collapse> -->
			<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate'>
				<van-button block type="info" @click="SaveInfo">保存</van-button>
			</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>

		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../base/components.js'

	export default {
		name: "page",
		data() {
			return {
				form: {
					bq403: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访编号
						bq001018: "", //患者编号
						bd001002: "", //类别名称
						bd002guid: "", //药物编号
						bd002002: "", //药物名称
						bq403004: "", //规格
						bq403006: "", //给药途径
						bq403008: "", //用量数值
						bq4030082: "", //用量单位
						bq403010: "", //用法
						bq403012: "", //备注
						bq403014: "", //开始用药时间
						bq403015: "", //是否正在服用此药（0-停，1-正常）
						bq4030152: "", //停药时间
						bq4030153: "", //停用说明
						Bq400_guid: '', //随访编号
						Bq001_018: '', //患者编号
						Bd001_002: '', //类别名称
						Bd002_guid: '', //药物编号
						Bd002_002: '', //药物名称
						Bq403_004: '', //规格
						Bq403_006: '', //给药途径
						Bq403_008: '', //用量数值
						Bq403_008_2: '', //用量单位
						Bq403_010: '', //用法
						Bq403_012: '', //备注
						Bq403_014: '', //开始用药时间
						Bq403_015: '', //是否正在服用此药（0-停，1-正常）
						Bq403_015_2: '', //停药时间
						Bq403_015_3: '', //停用说明
					},
					sempFiles: []
				},
				typeList: [],
				leftActive: 0,
				showPage: "page001",
				bq400: JSON.parse(sessionStorage.getItem('bq400')), //获取随访信息
				//已选择药物列表
				medList: [],
				treatmentSel: "", // 所选药物
				treatmentList: [], //所有药物
				hasmed: false, //显示药物添加确定按钮
				activeNames: [0],
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq403/Save',
				//更新数据接口
				putUrl: this.$utils.Url.s400 + '/api/S400Bq403/UpdateList',
				//移除接口
				deleteUtl: this.$utils.Url.s400 + '/api/S400Bq403/Delete',
				savestate:false,
			}
		},
		components: {
			...componentsModel,

		},
		methods: {
			//加载信息,获取所有用药记录
			LoadInfo: function() {
				var that = this
				var condition = {
					currentPage: 1,
					pageSize: 10000,
					recordCount: 0,
					bq400guid: that.bq400.guid //当前随访编号
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq403/AllList', condition, function(d) {
					let dataList = d.data
					dataList.forEach(function(item) {
						that.$utils.CopyKeyInfo(item, item)
						item.bq403008Name = item.bq403008 + item.bq4030082
						that.medList.push(item)
					})
					// that.medList = d.data
				}, null, null, null);
			},
			//保存药物
			addTreatment: function() {
				var that = this
				that.$utils.CopyKeySave(that.form.bq403, that.form.bq403)
				that.$utils.HttpPost(this.saveUrl, that.form, function(d) {
					that.hasmed = false
					that.$utils.CopyKeyInfo(d.Data, d.Data)
					that.medList.push(d.Data)
				}, null, null, null);
			},
			// 选择药物
			treatmentChange: function(item) {
				var that = this
				//判断是否已经存在于用药表中，并且是正常使用				
				let med = that.medList.find(m => {
					return m.bd002guid == item.guid && m.bq403015 == 1
				})

				if (med == undefined) {
					//没有此药物，显示按钮
					that.hasmed = true
					that.form.bq403.bq400guid = that.bq400.guid
					that.form.bq403.bq001018 = that.bq400.bq001018
					that.form.bq403.bd001002 = item.bd001002
					that.form.bq403.bd002002 = item.bd002002
					that.form.bq403.bd002guid = item.guid
					that.form.bq403.bq403015 = '1'
				} else {
					//有此药物，不允许添加
					that.hasmed = false
				}
			},
			// 移除药物
			removeMed: function(id, name) {
				var that = this
				let args={
					guid:id
				}
				that.$utils.DeleteNet(this.deleteUtl,args, name, () => {
					let colindex = that.medList.findIndex((item) => {
						return item.id == id
					})
					that.medList.splice(colindex, 1)
				})

			},
			//修改用药详细信息
			SaveInfo: function() {
				var that = this
				that.medList.forEach((item) => {
					that.$utils.CopyKeySave(item, item)
				})
				//保存到数据库
				var uform = {
					bq403Exes: that.medList
				}
				that.savestate=true
				that.$utils.HttpPut(this.putUrl, uform, function() {
					that.$dialog({
						message: '保存成功',
					})
					that.savestate=false
				}, null, null, null);
			},
		},
		mounted() {
			let that = this
			// 加载数据
			that.$apis.s400Apis.getAllTreatment(function(dataList) {
				that.treatmentList = dataList
			})
			// that.form.bq403.bq400guid = that.bq400.guid
			that.LoadInfo()
		}
	}
</script>

<style scoped>
	.add-btn-box {
		padding: 5px 20px;
		display: flex;
		justify-content: flex-end;
	}

	.no-label /deep/.van-field__label {
		width: 0;
	}
</style>
